"use strict";

angular.module("core")
.controller("EmailInputModalController", function($scope, $attrs, close, FormError, PatternService, EMAIL_MAXLENGTH) {
    $scope.EMAIL_MAXLENGTH = EMAIL_MAXLENGTH;
    $scope.title = $attrs.title;
    $scope.inputPlaceHolder = $attrs.inputPlaceHolder;
    $scope.formSent = false;
    $scope.email = $attrs.defaultEmail;
    $scope.pattern = PatternService;

    $scope.close = function(send) {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        if (send)
            close.apply(this, arguments);
    };

    // On form submit, focus on the first error element
    $scope.validate = function() {
        $scope.formSent = true;
        FormError.focus("recipientForm");
        if ($scope.recipientForm.$valid)
            send();
    };

    function send() {
        $scope.close($scope.email);
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/email-input-modal/email-input-modal.modal.js
// module id = 660
// module chunks = 0